import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { useParams } from 'react-router-dom';
import { Col, Row, Typography, Card, Spin, Layout } from 'antd';
import TramittaLogo from '../../images/tramitta-logo.png';
import LegalChileLogo from '../../images/legalchile.svg';
import { UserOutlined } from '@ant-design/icons';
import ShowPdf from '../../components/pdf/ShowPdf';
import Error from '../../components/Error';
import { STATUS } from '../../config/constants/states';
import { STATES } from '../../config/constants/contractStates';
import decode from '../../helpers/urlParamDecode';
import { RESOURCE } from '../../config/constants/alerts';
import { GET_CONTRACT_DATA_FORM, VERIFY_TOKEN } from '../../state/lease_contract/types';
import PropTypes from 'prop-types';

const { Title } = Typography;
const { Header, Content } = Layout;

const ShowContract = ({
  contract,
  contractPdf,
  verifyToken,
  getContract,
  tokenStatus
}) => {

  const { params } = useParams();

  const [tokenParams, setTokenParams] = useState('');
  const [valid, setIfValid] = useState(true);
  const [loaderSpinning, setLoaderSpinning] = useState(true);

  useEffect(() => {
    verifyToken(params);
    const data = decode(params);
    setTokenParams(data);
    if (data[0]) {
      getContract(data[0]);
    }
  }, []);

  useEffect(() => {
    if (tokenParams === STATUS.ERROR) {
      setIfValid(false);
      setLoaderSpinning(false);
    }
    if (tokenStatus !== '') {
      if (tokenStatus !== STATES.FINALIZED) {
        setIfValid(false);
        setLoaderSpinning(false);
      } else {
        setLoaderSpinning(false);
      }
    }
  }, [tokenParams, tokenStatus]);

  return (
    <>
      {loaderSpinning
        ? <Spin className="spin-centered" tip="Cargando..."></Spin>
        : <>
          {valid ?
            <>
              <Header className="border-0">
                <Row className="header-logos mb-0">
                  <img src={LegalChileLogo} alt="" className="legal-logo" />
                  <img src={TramittaLogo} alt="" className="tramitta-logo" />
                </Row>
              </Header>
              <Content className="ant-layout-content-custom">
                <Row>
                  <Col md={14} className="mx-auto">
                    <Title level={2}>Previsualización contrato de arriendo</Title>
                  </Col>
                </Row>
                <Row className="mb-4">
                  <Col md={14} className="mx-auto">
                    <Card>
                      <Row className="mb-2">
                        <Col>
                          <Title level={4}>Firmantes</Title>
                        </Col>
                      </Row>
                      <Row className="mb-4">
                        <Col md={8} className="d-flex">
                          <div className="circle-icon circle-purple circle-sign mb-4">
                            <UserOutlined style={{ fontSize: '20px' }} />
                          </div>
                          <div>
                            <Title level={5} className="mb-2">Arrendador</Title>
                            <p className="small">{contract.arrendador.nombre} {contract.arrendador.apellido} {contract.arrendador.segundoApellido}</p>
                          </div>
                        </Col>
                        <Col md={8} className="d-flex">
                          <div className="circle-icon circle-green circle-sign mb-4">
                            <UserOutlined style={{ fontSize: '20px' }} />
                          </div>
                          <div>
                            <Title level={5} className="mb-2">Arrendatario</Title>
                            <p className="small">{contract.arrendatario.nombre} {contract.arrendatario.apellido} {contract.arrendatario.segundoApellido}</p>
                          </div>
                        </Col>
                        {contract.codeudor &&
                          <Col md={8} className="d-flex">
                            <div className="circle-icon circle-blue circle-sign mb-4">
                              <UserOutlined style={{ fontSize: '20px' }} />
                            </div>
                            <div>
                              <Title level={5} className="mb-2">Codeudor</Title>
                              <p className="small">{contract.codeudor.nombre} {contract.codeudor.apellido} {contract.codeudor.segundoApellido}</p>
                            </div>
                          </Col>
                        }
                      </Row>
                    </Card>
                  </Col>
                </Row>
                <Row>
                  <Col md={14} className="mx-auto">
                    <ShowPdf pdf={contractPdf} id={tokenParams[0]} />
                  </Col>
                </Row>
              </Content>
            </>
            : <Error />
          }
        </>
      }
    </>
  );
};

ShowContract.propTypes = {
  contract: PropTypes.object.isRequired,
  contractPdf: PropTypes.string.isRequired,
  verifyToken: PropTypes.func.isRequired,
  getContract: PropTypes.func.isRequired,
  tokenStatus: PropTypes.string.isRequired,
};

const data = (state) => ({
  contract: state.contract.contract,
  contractPdf: state.contract.contractPdf,
  tokenStatus: state.contract.tokenStatus,
});

const action = (dispatch) => ({
  verifyToken: (token) => dispatch({ type: VERIFY_TOKEN, payload: token }),
  getContract: (id) => dispatch({ type: GET_CONTRACT_DATA_FORM, payload: { id, resource: RESOURCE.GET_CONTRACT } }),
});

export default connect(data, action)(ShowContract);